export default __webpack_public_path__ + "static/media/pag33.19e14d4c.jpg";